import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'editorials-component',
  templateUrl: './editorials.component.html',
  styleUrls: ['./editorials.component.css']
})
export class EditorialsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  
  @Input() notes = [];

  showFullDetail(note) {
    note.expanded = !note.expanded;
  }
}


// WEBPACK FOOTER //
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/articulo/notas/editorials/editorials.component.ts